<template>
  <div>
    <BListFilter
      v-model="form"
      label="Поиск по названию и описанию"
      :skeleton="skeleton"
      dense
      @change="onChangeDebounced"
    />

    <v-row dense>
      <v-col :cols="!skeleton && 'auto'">
        <BAutocompleteCommon
          v-model="form.event_id"
          label="Мероприятия"
          :options="events"
          :skeleton="skeleton"
          :return-object="false"
          item-text="name"
          item-value="event_id"
          $type="select"
          @change="onChangeDebounced"
        />
      </v-col>
      <v-col :cols="!skeleton && 'auto'">
        <BAutocompleteCommon
          v-model="form.session_id"
          label="Сессия"
          :options="sessions"
          :skeleton="skeleton"
          :return-object="false"
          item-text="name"
          item-value="session_id"
          $type="select"
          @change="onChangeDebounced"
        />
      </v-col>
      <v-col :cols="!skeleton && 'auto'">
        <BAutocompleteCommon
          v-model="form.procedure_id"
          label="Оценочная процедура"
          :options="procedures"
          :skeleton="skeleton"
          :return-object="false"
          item-text="name"
          item-value="procedure_id"
          $type="select"
          @change="onChangeDebounced"
        />
      </v-col>
      <v-col :cols="!skeleton && 'auto'">
        <BAutocompleteCommon
          v-model="form.subject_id"
          label="Предмет"
          :options="subjects"
          :skeleton="skeleton"
          :return-object="false"
          item-text="name"
          item-value="subject_id"
          $type="select"
          @change="onChangeDebounced"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'


const createDefaultDataFilters = () => ({
  ...createDefaultData(),
  is_archived: null,
})

const ARCHIVED_OPTIONS = [
  { label: 'В архиве', value: true },
  { label: 'Не в архиве', value: false },
]

export default {
  name: 'BasePublicationsFilter',
  components: {
    BListFilter,
    BAutocompleteCommon,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFilters,
    },
  },
  data: () => ({
    archivedOptions: ARCHIVED_OPTIONS,
  }),
  watch: {
    'form.event_id': [async function () {
      await this.fetchSessions();
    },
    async function () {
      await this.fetchProcedures();
    },
    ],
    'form.session_id': async function () {
      await this.fetchProcedures();
    }
  },
}
</script>
